import axios from 'axios';
import {
  PUSH_TO_TIMELINE_POINTS,
  SET_ACTIVE_TIMELINE_POINT,
  SET_TIMELINE_POINTS,
  DELETE_TIMELINE_POINT,
} from '@/store/actions/timeline';

const state = () => ({
  timelinePoints: [],
  activeTimelinePoint: null,
});

/* eslint-disable no-shadow, arrow-body-style */
const getters = {
  getTimelinePoints: (state) => state.timelinePoints,
  getTimelinePointByIndex: (state) => (index) => {
    return state.timelinePoints[index];
  },
  getActiveTimelinePoint: (state) => state.activeTimelinePoint,
};
/* eslint-enable */

const actions = {
  PUSH_TO_TIMELINE_POINTS: ({ commit }, payload) => {
    commit(PUSH_TO_TIMELINE_POINTS, payload);
  },
  SET_ACTIVE_TIMELINE_POINT: ({ commit }, index) => {
    commit(SET_ACTIVE_TIMELINE_POINT, index);
  },
  FETCH_TIMELINE_POINTS: ({ commit }, layoutID) => {
    axios.get(`${window.api_url}api/layout/${layoutID}/timeline`)
      .then((response) => {
        commit(SET_TIMELINE_POINTS, response.data.data);
      });
  },
  DELETE_TIMELINE_POINT: ({ commit }, index) => {
    commit(DELETE_TIMELINE_POINT, index);
  },
};

/* eslint-disable no-shadow, arrow-body-style, no-param-reassign */
const mutations = {
  PUSH_TO_TIMELINE_POINTS: (state, payload) => {
    state.timelinePoints.push(payload);

    state.timelinePoints.sort((pt1, pt2) => {
      return pt1.time - pt2.time;
    });
  },
  SET_TIMELINE_POINTS: (state, timelinePoints) => {
    state.timelinePoints = timelinePoints;
  },
  SET_ACTIVE_TIMELINE_POINT: (state, index) => {
    state.activeTimelinePoint = index;
  },
  RESET_TIMELINE_STATE: (s) => {
    const initial = state();

    Object.keys(initial).forEach((key) => {
      s[key] = initial[key];
    });
  },
  DELETE_TIMELINE_POINT: (state, index) => {
    state.timelinePoints.splice(index, 1);
  },
};
/* eslint-enable */

export default {
  state,
  getters,
  actions,
  mutations,
};
